import { render, staticRenderFns } from "./OppregWorkload.vue?vue&type=template&id=f53a1816&scoped=true&"
import script from "./OppregWorkload.vue?vue&type=script&lang=js&"
export * from "./OppregWorkload.vue?vue&type=script&lang=js&"
import style0 from "./OppregWorkload.vue?vue&type=style&index=0&id=f53a1816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53a1816",
  null
  
)

export default component.exports